import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import type { Timestamp } from "firebase/firestore";
import { getFirebaseFirestore } from "@/config/firebase";
import { isDemoMode } from "@/demo/demoMode";
import * as demoStore from "@/demo/demoStore";
import type { InstructorSettlement } from "@vlab-corporation/vlab-pilates-service-interface/settlement";
import type { SettlementStatus } from "@vlab-corporation/vlab-pilates-service-interface/settlement";
import type { YearMonth } from "@vlab-corporation/vlab-pilates-service-interface/types";

export interface SettlementDocument {
  yearMonth: YearMonth;
  status: SettlementStatus;
  instructorSettlements: InstructorSettlement[];
  calculatedAt: Timestamp | null;
}

function settlementRef(ownerUid: string, centerId: number, yearMonth: YearMonth) {
  return doc(
    getFirebaseFirestore(),
    "users",
    ownerUid,
    "centers",
    String(centerId),
    "settlements",
    yearMonth,
  );
}

export async function getSettlement(
  ownerUid: string,
  centerId: number,
  yearMonth: YearMonth,
): Promise<SettlementDocument | null> {
  if (isDemoMode()) return demoStore.getSettlement(centerId, yearMonth);
  const snap = await getDoc(settlementRef(ownerUid, centerId, yearMonth));
  if (!snap.exists()) return null;
  return snap.data() as SettlementDocument;
}

export async function saveSettlement(
  ownerUid: string,
  centerId: number,
  data: Omit<SettlementDocument, "calculatedAt">,
): Promise<void> {
  if (isDemoMode()) return demoStore.saveSettlement(centerId, data);
  await setDoc(settlementRef(ownerUid, centerId, data.yearMonth), {
    ...data,
    calculatedAt: serverTimestamp(),
  });
}
